import axios from 'axios';

export function activateAdvertiserAccount(token, payload) {
    return axios.post(process.env.REACT_APP_API_URL + '/advertiser/activate', payload, {
        headers: {
            Authorization: token
        }
    });
}
